import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '@shared/stores/AuthContext'

export function RouteLoader() {
    return (
        <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--color-paper)' }}>
            <div
                className="w-10 h-10 rounded-full animate-spin"
                style={{ border: '3px solid var(--color-rule)', borderTopColor: 'var(--color-gold-500)' }}
            />
        </div>
    )
}

const AuthorDashboard = lazy(() => import('@features/dashboard/AuthorDashboard'))
const ReviewerDashboard = lazy(() => import('@features/dashboard/ReviewerDashboard'))
const AdminEditorDashboard = lazy(() => import('@features/dashboard/AdminEditorDashboard'))

export default function DashboardRouter() {
    const { user } = useAuth()
    if (!user) return <Navigate to="/dashboard/login" replace />
    if (user.role === 'author') return <AuthorDashboard />
    if (user.role === 'reviewer') return <ReviewerDashboard />
    if (user.role === 'editor' || user.role === 'admin') return <AdminEditorDashboard />
    return <Navigate to="/dashboard/login" replace />
}
